import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-method',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './payment-method.component.html',
  styleUrl: './payment-method.component.scss',
})
export class PaymentMethodComponent {
  selectedOption: any;
  doneChoose: any = false;

  constructor(
    public dialogRef: MatDialogRef<PaymentMethodComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {}

  closeDialog(): void {
    this.dialogRef.close(true);
  }

  submit(): void {
    if (this.selectedOption && this.selectedOption == 'Bank Transfer') {
      this.doneChoose = true;
    } else {
      this.dialogRef.close(this.selectedOption);
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
